import { observable } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/observable.js?vue3';

export const badgeState = observable('mr_badge_state', {
  state: '',
  updateStatus: null,
});
